var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    className: "wd-accent-people-group wd-accent",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    className: "wd-icon-container"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DBA",
    d: "M34.71 23.999a7.99 7.99 0 0 1 2.821-1.61A6.986 6.986 0 0 1 35 17v-5a7 7 0 0 1 14 0v5a6.986 6.986 0 0 1-2.531 5.388A8.004 8.004 0 0 1 52 30v7H35.876A7.998 7.998 0 0 1 40 44v7H16v-7a7.998 7.998 0 0 1 4.124-7H4v-7a8.004 8.004 0 0 1 5.531-7.612A6.986 6.986 0 0 1 7 17v-5a7 7 0 0 1 14 0v5a6.986 6.986 0 0 1-2.531 5.388 7.99 7.99 0 0 1 2.821 1.61 7.003 7.003 0 0 1 13.42 0zM21 26.682A5.994 5.994 0 0 0 16 24h-4a6 6 0 0 0-6 6v5h16v-.392A6.967 6.967 0 0 1 21 31v-4.318zm13 7.926V35h16v-5a6 6 0 0 0-6-6h-4a5.994 5.994 0 0 0-5 2.682V31c0 1.32-.365 2.554-1 3.608zM14 7a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0v-5a5 5 0 0 0-5-5zm28 0a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0v-5a5 5 0 0 0-5-5zM24 38a6 6 0 0 0-6 6v5h20v-5a6 6 0 0 0-6-6h-8zm4-17a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0v-5a5 5 0 0 0-5-5z",
    className: "color-500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21 26.682A5.994 5.994 0 0 0 16 24h-4a6 6 0 0 0-6 6v5h16v-.392A6.967 6.967 0 0 1 21 31v-4.318zm13 7.926V35h16v-5a6 6 0 0 0-6-6h-4a5.994 5.994 0 0 0-5 2.682V31c0 1.32-.365 2.554-1 3.608zM14 7a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0v-5a5 5 0 0 0-5-5zm28 0a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0v-5a5 5 0 0 0-5-5zM24 38a6 6 0 0 0-6 6v5h20v-5a6 6 0 0 0-6-6h-8zm4-17a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0v-5a5 5 0 0 0-5-5z",
    className: "french-vanilla-100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.854bd8e4b11c2a7d4661cadf4d570982.svg";
export { ForwardRef as ReactComponent };